export default __webpack_public_path__ + "static/media/Contact_Icon-03.44fc3b11.png";